export function buildQueryParams(filter: Record<string, any>): string {
  const params = new URLSearchParams();
  const { page, limit, search, sort, order, total, totalPages, ...rest } = filter;

  Object.entries(rest).forEach(([key, value]) => {
    // 👇 garante que tanto true quanto false sejam enviados
    if (typeof value === "boolean") {
      params.append(key, String(value));
      return;
    }

    // 👇 trata números (ex: ano = 2024)
    if (typeof value === "number") {
      params.append(key, value.toString());
      return;
    }

    if (!value) return;

    if (Array.isArray(value) && value.length > 0) {
      params.append(key, value.join(","));
    } else if (typeof value === "object" && (value.from || value.to)) {
      if (value.from) params.append(`${key}From`, value.from);
      if (value.to) params.append(`${key}To`, value.to);
    } else if (typeof value === "string") {
      params.append(key, value);
    }
  });

  if (page) params.append("page", page.toString());
  if (limit) params.append("limit", limit.toString());
  if (search) params.append("search", search);
  if (sort) params.append("sort", sort);
  if (order) params.append("order", order);

  return params.toString();
}
